// TODO this won't currently work if there's more than one anim onpage

(function () {
    'use strict';

    const tabletThresh = 700;

    const paragraphs = document.querySelectorAll('.js-paragraphIntersector');
    const stickyCont = document.querySelector('.js-stickyCont');
    const crossMiddle = document.querySelector('.js-crossMiddle');
    const crossBottom = document.querySelector('.js-crossBottom');
    const cross = document.querySelector('.js-cross');
    const crossStickyParent = document.querySelector('.js-crossStickyParent');
    const crossStickyContainer = document.querySelector('.js-crossStickyContainer');

    let crossStickyContainerHeight = 0;
    let crossStickyTop = 0;
    let crossHeight = 0;
    let crossMiddleRect;
    let crossBottomRect;

    function handleScrollEvent() {

        paragraphs.forEach(function (elm) {
            let elmRect = elm.getBoundingClientRect();
            let squareRevealThresh = 0;

            if (window.matchMedia(`(min-width: ${tabletThresh}px)`).matches) {
                // tablet+ version
                crossMiddleRect = crossMiddle.getBoundingClientRect();
                squareRevealThresh = crossMiddleRect.top - 20;

            } else {
                // mobile version
                if (stickyCont.offsetTop > 0) {
                    crossBottomRect = crossBottom.getBoundingClientRect()
                    squareRevealThresh = (crossBottomRect.top + (crossBottomRect.height * 1.5));
                } else {
                    squareRevealThresh = false;
                }
            }

            if (squareRevealThresh !== false && elmRect.top < squareRevealThresh) {
                const idCrossSquare = elm.dataset.squarenumber;
                const squareToAddClassTo = cross.querySelector(`[data-squarenumber="${idCrossSquare}"`);

                if (squareToAddClassTo) {
                    squareToAddClassTo.classList.add('active');
                }
            }

        });

        // this is a bodge to get the final quadrant of the square to fill in if the end of the page has been reached
        // Check if the user has scrolled to the bottom of the page
        if ((window.innerHeight + window.scrollY) >= (document.body.scrollHeight - 50)) {
            // Here you can trigger any actions or functions you want
            const squares = cross.querySelectorAll('.scrollingcross__crossLayout__square');

            if (squares) {
                squares.forEach(function (elm) {
                    elm.classList.add('active');
                });
            }
        }
    }


    function setupCross() {
        if (window.matchMedia(`(min-width: ${tabletThresh})`).matches) {
            // tablet+ version
            crossHeight = cross.clientHeight;
            crossStickyContainerHeight = crossStickyContainer.clientHeight;

            const vpHeight = window.innerHeight;

            crossStickyTop = (vpHeight / 2) - (crossHeight / 2);
            crossStickyParent.style.top = Math.round(crossStickyTop) + 'px';
        } else {
            // mobile version
        }
    }


    function handleWindowResizeEvent() {
        crossMiddleRect = crossMiddle.getBoundingClientRect();
        setupCross();
    }


    if (crossMiddle && cross) {
        setupCross();
        handleScrollEvent();
        window.addEventListener('scroll', handleScrollEvent);
        window.addEventListener('resize', handleWindowResizeEvent);
    }

})();